import React from 'react'

const MenuArrow = () => (
	<svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M17.1339 7.86611C17.622 8.35427 17.622 9.14573 17.1339 9.63388C16.6457 10.122 15.8542 10.122 15.3661 9.63388L8.75 3.01776L2.13389 9.63388C1.64573 10.122 0.854272 10.122 0.366117 9.63388C-0.122039 9.14573 -0.122039 8.35427 0.366117 7.86611L7.86611 0.366113C8.35427 -0.122038 9.14572 -0.122038 9.63389 0.366113L17.1339 7.86611Z" fill="#284249"/>
	</svg>
) 

export default MenuArrow